<template>
  <b-row class="tri">
    <b-col
      cols="12"
      md="6"
      class="label-input-row"
      @click="displayModalEdition"
    >
      <label :for="'ordering_' + index">Tri {{ index + 1 }}&nbsp;:</label>
      <Multiselect
        :id="'ordering_' + index"
        v-model="value.ordering"
        :options="champsTri"
        v-bind="defaultAttr"
        label="value"
        track-by="key"
        select-label
        selected-label
        deselect-label
        open-direction="bottom"
      >
        <span slot="noOptions">{{ optionMultiselect.emptyMessage }}</span>
        <span slot="noResult">{{ optionMultiselect.noResult }}</span>
      </Multiselect>
    </b-col>
    <b-col
      cols="12"
      md="6"
      class="order-suppr"
      @click="displayModalEdition"
    >
      <div class="label-input-row">
        <label :for="'sens_ordering_' + index">Sens du tri&nbsp;:</label>
        <div class="align-middle-flex">
          <Multiselect
            :id="'sens_ordering_' + index"
            v-model="value.sens_ordering"
            :options="sensOrder"
            v-bind="defaultAttr"
            label="value"
            track-by="key"
            select-label
            selected-label
            deselect-label
            open-direction="bottom"
          >
            <span slot="noOptions">{{ optionMultiselect.emptyMessage }}</span>
            <span slot="noResult">{{ optionMultiselect.noResult }}</span>
          </Multiselect>
          <i
            class="fas fa-times hover-red"
            title="Supprimer ce tri"
            @click="!disabled ? deleteRow() : ''"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Multiselect from "vue-multiselect";

import MixinModalEdition from "@/mixins/mixinModalEdition";
import MixinMultiselect from "@/mixins/mixinMultiselect";

export default {
  name: "Tri",
  components: { Multiselect },
  mixins: [MixinModalEdition, MixinMultiselect],
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    /**
     * Définit si le champ est éditable ou non.
     */
    disabled: Boolean,
    /**
     * Définit l'index du champ de tri.
     */
    index: {
      type: Number,
      required: true,
    },
    /**
     * Définit les infos du tri.
     */
    value: {
      type: Object,
      required: true,
    },
    /**
     * Définit les champs triables.
     */
    champsTri: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sensOrder: [
        { key: "+", value: "Croissant" },
        { key: "-", value: "Décroissant" },
      ],
      optionMultiselect: {
        noResult: "Aucun résultat.",
        emptyMessage: "Tapez 2 caractères min.",
        emptyMessageSousTheme: "Aucun sous-thème dans ce thème.",
      },
    };
  },
  methods: {
    /**
     * Envoie au composant parent la demande de suppression d'une ligne.
     * @public
     */
    deleteRow() {
      this.$emit("delete-row");
    },
    /**
     * Cette fonction doit être définie à cause de la mixin qui l'exécute au mounted().
     */
    initForm() {},
  },
};
</script>

<style lang="scss" scoped>
.tri {
  .order-suppr {
    display: flex;
    .label-input-row { width: 100%; }
    .fa-times { margin-left: 0.5rem;}
    .align-middle-flex {
      width: 100%;
      .multiselect { max-width: 100%; }
    }
  }
}
</style>
